import {
  REQUEST_GET_ORDERS, REQUEST_GET_ORDERS_SUCCESS, REQUEST_GET_ORDERS_FAILED,
  REQUEST_PATCH_ORDER, REQUEST_PATCH_ORDER_SUCCESS, REQUEST_PATCH_ORDER_FAILED,
  REQUEST_POST_ORDERS, REQUEST_POST_ORDERS_SUCCESS, REQUEST_POST_ORDERS_FAILED,
  CLEAR_ORDERS
} from "../actions/orders_actions";


const initialState = {
  count: 0,
  pages: 0,
  next: null,
  previous: null,
  orders: [],
}


export const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GET_ORDERS: {
      return {
        ...state
      }
    }
    case REQUEST_GET_ORDERS_SUCCESS: {
      return {
        ...state,
        count: action.payload.count,
        pages: action.payload.pages,
        next: action.payload.links.next,
        previous: action.payload.links.previous,
        orders: [...action.payload.results],
      }
    }
    case REQUEST_GET_ORDERS_FAILED: {
      return {
        ...state,
        count: 0,
        pages: 0,
        next: null,
        previous: null,
        orders: []
      }
    }
    // case REQUEST_PATCH_ORDER: {
    //   return {
    //     ...state
    //   }
    // }
    // case REQUEST_PATCH_ORDER_SUCCESS: {
    //   return {
    //     ...state,
    //     count: action.payload.count,
    //     pages: action.payload.pages,
    //     next: action.payload.links.next,
    //     previous: action.payload.links.previous,
    //     orders: [...action.payload.results],
    //   }
    // }
    // case REQUEST_PATCH_ORDER_FAILED: {
    //   return {
    //     ...state
    //   }
    // }
    case CLEAR_ORDERS: {
      return {
        ...state,
        count: 0,
        pages: 0,
        next: null,
        previous: null,
        orders: []
      }
    }
    default: return state;
  }
}
